import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { FormTextField } from "./FormTextField";
import { StepContentProps } from "./BusinessInfoTypes";
import { Box } from "@mui/material";
import { useThemeMode } from "../../contexts/ThemeModeContext";
import { ControlledFileInput } from "./ControlledFileInput";

/**
 * Step 1: Company Details (Simple Controlled Form)
 */
export const StepCompanyDetails: React.FC<StepContentProps> = ({
  formData,
  setFormData,
}) => {
  //Add useThemeMode here
  const { mode } = useThemeMode();

  return (
    <div className="space-y-4">
      <Typography
        variant="h5"
        component="h2"
        sx={{ mt: 3, mb: 1 }}
        className="!mb-4 text-gray-700"
      >
        1. Company Details
      </Typography>

      <Box
        sx={{
          p: 1,
          px: 3,
          borderRadius: "20px",
          border: mode === "dark" ? "1px solid #374151" : " 1px solid #e5e7eb", // adjust colors if needed
        }}
      >
       
         
    <FormTextField
      label="Company Name"
      value={formData.companyName}
      required
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          companyName: value,
        }))
      }
      />
    <ControlledFileInput
      label="Upload Logo"
      value={formData.logo || []}
      folderPath="/Business_info"
      multiple={false}
        resizeTo50={true} 
      onChange={(files: any) =>
        setFormData((prev) => ({
          ...prev,
          logo: files,
        }))
      }
    />
          

        <FormTextField
          label="Company Description (20+ chars)"
          multiline
             required
          rows={3}
          value={formData.companyDescription}
          onChange={(value) =>
            setFormData((prev) => ({
              ...prev,
              companyDescription: value,
            }))
          }
        />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormTextField
              label="Official Website URL"
              type="url"
                 required
              value={formData.website}
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  website: value,
                }))
              }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormTextField
              label="Full Address"
              required
              value={formData.address}
              onChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  address: value,
                }))
              }
            />
          </Grid>
        </Grid>

        <FormTextField
          label="What is your 5-year growth plan? (50+ chars)"
          multiline
          rows={4}
             required
          value={formData.growthPlan}
          onChange={(value) =>
            setFormData((prev) => ({
              ...prev,
              growthPlan: value,
            }))
          }
        />
      </Box>
    </div>
  );
};
